import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, EventDeleteRequest, EventGetListRequest, EventGetListResponse, EventInsertRequest } from '../models';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllEvents(body: EventGetListRequest) {
    const link = this.apiUrl + ApiUrls.getEvents;
    return this.http.post<EventGetListResponse>(link, body);
  }

  getEvent(id: any) {
    const link = this.apiUrl + ApiUrls.getEvent;
    return this.http.get<any>(link+"/"+id );
  }

  deleteEvent(body: EventDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteEvent;
    return this.http.post<BaseResponse>(link, body);
  }

  insertEvent(body: FormData) {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });
    const link = this.apiUrl + ApiUrls.insertEvent;
    return this.http.post<BaseResponse>(link, body,{headers:headers});
  }
  updateEvent(body: EventInsertRequest) {
    const link = this.apiUrl + ApiUrls.updateEvent;
    return this.http.post<BaseResponse>(link, body);
  }

  getEventStatusCount() {
    const link = this.apiUrl + ApiUrls.getEventCountStatus;
    return this.http.get<any>(link);
  }
}
